import classNames from "classnames";

export const wrapper = classNames("w-full", "pt-10", "pb-10", "bg-[#f1f2f4]");
export const blogs = classNames(
  "overflow-hidden",
  "mt-10",
  "text-white",
  "flex",
  "items-center",
  "justify-center"
);
